import { Component, inject, OnInit } from '@angular/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { GenericProfileService } from '@/shared/services/profile.service';
import { Role } from '@/core/models/auth.interface';

import { TagComponent } from '@/shared/ui-components/tag/tag.component';
import { AppMenu } from '../menu/app.menu';
import { AvatarComponent } from '@/shared/ui-components/avatar/avatar.component';
import { UserProfileService } from '@/pages/user-profile/user-profile.service';

@Component({
    selector: 'app-sidebar',
    standalone: true,
    imports: [AppMenu, AngularSvgIconModule, CommonModule, ButtonModule, TagComponent, AvatarComponent],
    templateUrl: './app.sidebar.html',
    host: { class: 'block h-full' }
})
export class AppSidebar implements OnInit {
    public isClientUser: boolean = false;
    public isRelationshipManagerUser: boolean = false;
    public isWealthManagerUser: boolean = false;
    private readonly _router = inject(Router);
    private readonly _profileService = inject(GenericProfileService);
    public readonly _userProfileService = inject(UserProfileService);

    constructor() {
        const role = this._profileService.genericProfile()?.role;
        this.isClientUser = role === Role.CLIENT;
        this.isRelationshipManagerUser = role === Role.RELATIONSHIP_MANAGER;
        this.isWealthManagerUser = role === Role.WEALTH_MANAGER_SUPER_USER || role === Role.WEALTH_MANAGER_DEALS || role === Role.WEALTH_MANAGER_USERS;
    }

    public ngOnInit(): void {
        this._userProfileService.getUserProfile();
    }

    public redirectToDashboard(): void {
        this._router.navigate(['/']);
    }
}
